import { useRef, useState } from 'react';
import { Container, Name, Action, Result } from './styled';
import { toast } from 'react-toastify';
import { useVideoCall } from '../../../../contexts/videoCall';
import { AiOutlineLink } from 'react-icons/ai';
import { MdOutlineContentCopy } from 'react-icons/md';

export function ExternalLink(props) {

  const { customer } = props;
  const { inviteGuestExternal } = useVideoCall();

  const refLink = useRef();

  const [name, setName] = useState('');
  const [link, setLink] = useState('');

  async function handGenerateLink() {
    if (!name) return toast.warn('Por Favor ! insira um nome', { position: "top-right", autoClose: 5000, });
    const invite = await inviteGuestExternal({ name, rootCustomer: customer });
    setLink(invite);
    toast.success('Link gerado com sucesso', { position: "top-right", autoClose: 5000, });
  };

  async function handCopy() {
    refLink.current.select();
    document.execCommand('copy');
    toast.success('link copiado', { position: "top-right", autoClose: 5000, icon: <MdOutlineContentCopy /> });
  };

  return (
    <Container>
      <Name>
        <div>
          <input type="text" placeholder={"Digite o nome do participante..."} value={name} onChange={(e) => setName(e.target.value)} />
        </div>
      </Name>
      <Action>
        <button onClick={() => handGenerateLink()}>Gerar</button>
      </Action>
      <Result isEnable={link ? 1 : 0}>
        <label>Seu link é </label>
        <div className='link'>
          <AiOutlineLink />
          <input type="text" defaultValue={link} ref={refLink} />
        </div>
        <button className='copy' onClick={() => handCopy()}>
          Copiar
          <MdOutlineContentCopy className='icon' />
        </button>
      </Result>
    </Container>
  );
}